import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, MenuItem, Typography , FormControl, InputLabel,Select } from '@mui/material';
import { saveSupplierInfo, getCompanyTypes, updateSupplierInfo,checkSupplierNameExists } from '../service/supplierService'; // Assume these services exist
import { useAuth } from '../context/AuthContext';

export default function SupplierForm({ data, updateData, handleNext }) {
     const { userSupplier , loginSupplier } = useAuth();
  const [companyTypes, setCompanyTypes] = useState([]);
  const [formData, setFormData] = useState({
    supplierName: data?.supplierName || '',
    email: data?.email || userSupplier.email || '',
    phone: data?.phone || '',
    contactPerson: data?.contactPerson || '',
    gstNumber: data?.gstNumber || '',
    panNumber: data?.panNumber || '',
    website: data?.website || '',
    companyType: data?.companyType || '', // Will be ID of companyType selected
  });


  
  useEffect(() => {
    console.log("updateddata: ", updateData);
    async function fetchCompanyTypes() {
      try {
        const response = await getCompanyTypes(); // API to get company types
        setCompanyTypes(response.data);
      } catch (error) {
        console.error('Failed to load company types', error);
      }
    }
    fetchCompanyTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async () => {
    
    // check if the name already exist 
    // add validation of supplier form 
    
    if (!formData.supplierName)
    {
      alert("Please fill the supplier Name.");
    return;
    }
       if (!formData.email)
    {
      alert("Please fill the supplier Email Id.");
    return;
    }
       if (!formData.companyType)
    {
      alert("Please fill the Company Type.");
    return;
    }
       if (!formData.phone)
    {
      alert("Please fill the supplier phone number.");
    return;
    }
   // const resp = await validateSupplier(formData.supplierName,formData.email,formData.phone);
    
   const validationResult = await checkSupplierNameExists({name: formData.supplierName,
                                                           email: formData.email,
                                                           phone: formData.phone });
    console.log("conflitct ",validationResult.isConflict);
 if (validationResult.isConflict) {
     // Use validationResult.field to set the error state on the correct input
     // Use validationResult.message to display the text
   alert(validationResult.message);
   return;
 }else if(validationResult.message){
   alert(validationResult.message);
   return;
 }
      
    try {
    //  await saveSupplierInfo(formData); // Save supplier info to server
      updateData('supplierName', formData.supplierName);
      updateData('email', formData.email);
      updateData('phone', formData.phone);
      updateData('contactPerson', formData.contactPerson);
      updateData('gstNumber', formData.gstNumber);
      updateData('panNumber', formData.panNumber);
      updateData('website', formData.website);
      updateData('companyType', formData.companyType);
       updateData('userId', userSupplier.userId);
      handleNext();
    } catch (error) {
      console.error('Error saving supplier info:', error);
    }
  };
  
    const handleUpdate = async () => {
      
    if (!formData.supplierName)
    {
      alert("Please fill the supplier Name.");
    return;
    }
       if (!formData.email)
    {
      alert("Please fill the supplier Email Id.");
    return;
    }
       if (!formData.companyType)
    {
      alert("Please fill the Company Type.");
    return;
    }
    if (!formData.phone)
    {
      alert("Please fill the supplier phone number.");
    return;
    }
      
    try {
      await updateSupplierInfo(data.supplierId, formData); // update supplier info to server
      updateData('supplierName', formData.supplierName);
      updateData('email', formData.email);
      updateData('phone', formData.phone);
      updateData('contactPerson', formData.contactPerson);
      updateData('gstNumber', formData.gstNumber);
      updateData('panNumber', formData.panNumber);
      updateData('website', formData.website);
      updateData('companyType', formData.companyType);
       updateData('userId', userSupplier.userId);
      handleNext();
    } catch (error) {
      console.error('Error saving supplier info:', error);
    }
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>Supplier Information</Typography>
    <TextField
  name="supplierId"
  value={formData.supplierId}
  onChange={handleChange}
  type="hidden"
/>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField 
            label="Supplier Name"
            name="supplierName"
            value={formData.supplierName}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField 
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField 
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField 
            label="Contact Person"
            name="contactPerson"
            value={formData.contactPerson}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField 
            label="GST Number"
            name="gstNumber"
            value={formData.gstNumber}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField 
            label="PAN Number"
            name="panNumber"
            value={formData.panNumber}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField 
            label="Website"
            name="website"
            value={formData.website}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6}>
      
      <FormControl fullWidth variant="outlined" margin="normal">
  <InputLabel id="companyType-label">Company Type</InputLabel>
  <Select
    labelId="companyType-label"
    id="companyType"
    value={formData.companyType?.typeName || ""}
    onChange={(e) => {
      const selectedType = companyTypes.find((type) => type.typeName === e.target.value);
      setFormData({ ...formData, companyType: selectedType });
    }}
    label="Company Type"
    required
  >
    <MenuItem value="">
      <em>Select Company Type</em>
    </MenuItem>
    {companyTypes.map((type) => (
      <MenuItem key={type.id} value={type.typeName}>
        {type.typeName}
      </MenuItem>
    ))}
  </Select>
</FormControl>
        </Grid>
        <Grid item xs={12}>
                {!data.supplierId ? (
                 <>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Save and Next
          </Button>
        </>
      ) : (
                  <Button variant="contained" color="primary" onClick={handleUpdate}>
            Update
          </Button>
         )}
        </Grid>
      </Grid>
    </div>
  );
}